/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithEmail
 */
export interface WithEmailOptional {
  /**
   *
   * @type {string}
   * @memberof WithEmail
   */
  email?: string;
}

export interface WithEmail extends WithEmailOptional {
  /**
   *
   * @type {string}
   * @memberof WithEmail
   */
  email?: string;
}

export interface WithEmailTrackedI {
  /**
   *
   * @type {string}
   * @memberof WithEmail
   */
  email?: string;
  emailIsSet: boolean;
}

transformDatesMap.set("WithEmail", function (model: WithEmail) {});

export type WithEmailMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
}>;

export var WithEmailMeta: WithEmailMetaI = {} as WithEmailMetaI;
WithEmailMeta = typeMeta("WithEmail", {
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
});

const metaI = WithEmailMeta;

registerMeta(() => {});

export class WithEmailTracked implements WithEmailTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  constructor(config?: WithEmailOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithEmailOptional,
    options?: AssignOptions,
  ): WithEmailTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithEmailTrackedI {
    const cloned = {} as WithEmailTrackedI;
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithEmailTrackedI {
    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    return this;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(WithEmailMeta.email, WithEmailMeta, this.email, this);
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.emailIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
